import API from '@/models/API';

export default class Product {
  constructor(item = {}) {
    this.product_id = item.product_id || null;
    this.product_tag_id = item.product_tag_id || null;
    this.name = item.name || {
      el: '',
      en: '',
      it: '',
    };
    this.description = item.description || {
      el: '',
      en: '',
      it: '',
    };
    this.retail_price = item.retail_price || null;
    this.wholesale_price = item.wholesale_price || null;
    this.reward_points = item.reward_points || null;
    this.reward_type_id = item.reward_type_id || null;
    this.reward_points_shared = item.reward_points_shared || false;
    this.reward_points_shared_options = item.reward_points_shared_options || {
      online: false,
      offline: false,
    };
    this.availability_days = item.availability_days || [];
    this.published = item.published || false;
    this.group_product = item.group_product || false;
    this.image = item.image || '';
    this.has_valid_period = !!item.valid_from || !!item.valid_to;
    this.valid_from = item.valid_from;
    this.valid_to = item.valid_to;
    this.update_store_products = item.update_store_products || {
      status: false,
      prices_included: false,
    };
    this.sku_number = item.sku_number || null;
    this.loyalty_program_ids = item.loyalty_program_ids || [];
    this.maximum_price_per_transaction = item.maximum_price_per_transaction || null;
    this.store_ids = item.store_ids || null;
    this.stores = item.stores || null;
    this.has_image = item.has_image || false;
  }

  static getCategories = () =>
    API.get(`/stores/${localStorage.getItem('storeId')}/product-categories`);

  static getProductsTags = () =>
    API.get(`/companies/${localStorage.getItem('storeId')}/products/tags?page=1`);

  static get = (query) => API.get(`/companies/${localStorage.getItem('storeId')}/products${query}`);

  static create = (item) =>
    API.post(`/companies/${localStorage.getItem('storeId')}/products`, item);

  static update = (item) =>
    // console.log('req',item)&&
    API.put(`/companies/${localStorage.getItem('storeId')}/products/${item.product_id}`, item);

  static delete = (id) =>
    API.delete(`/companies/${localStorage.getItem('storeId')}/products/${id}`);

  static uploadImage = (id, image) =>
    API.post(`/companies/${localStorage.getItem('storeId')}/products/${id}/images`, image);

  static uploadProductsCsv = (file) =>
    API.post(`/companies/${localStorage.getItem('storeId')}/products/csv`, file);

  static updateBulk = (id, body) =>
    API.patch(`/companies/${localStorage.getItem('storeId')}/products/bulk/${id}`, body);
}
